var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('approve-list',{key:_vm.flag,attrs:{"title":_vm.title,"type":_vm.flag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }